<template>
  <modal name="TasksEdit" :width="800" height="auto" :scrollable="false" :adaptive="false" @closed="modalHide(false)">
    <div data-modal="task" class="panel mb-0">
      <div class="panel-hdr">
          <div class="w-100">
              <div class="row">
                  <div class="col-lg-12">
                      <h1 class="subheader-title mb-lg-0">
                          <i class="subheader-icon fal fa-window"></i> Изменение задачи
                      </h1>
                      <button type="button" class="close" @click="modalHide(false)">
                          <i class="fal fa-times"></i>
                      </button>
                  </div>
              </div>
          </div>
      </div>
      <div class="panel-container show" v-if="loading">
        <div class="panel-content p-6 m-6">
          <content-placeholders :centered="true">
            <content-placeholders-text :lines="4" />
          </content-placeholders>
        </div>
      </div>
      <div class="panel-container show" v-if="!loading">
          <div class="panel-content">
            <form data-form="edit" @submit.prevent="taskUpdate">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label class="form-label">Название задачи</label>
                        <input type="text" data-input="name" class="form-control" v-bind:class="{ 'is-invalid': 'name' in errors}" v-on:focus="$delete(errors, 'name')" v-model="task.name">
                        <div class="invalid-feedback" v-if="'name' in errors">{{ errors['name'] }}</div>
                    </div>
                    <div class="form-group">
                        <label class="form-label" v-if="task.type == 'http'">Адрес сайта</label>
                        <label class="form-label" v-if="task.type == 'ping'">Адрес сервера</label>
                        <input type="text" data-input="value" class="form-control" v-bind:class="{ 'is-invalid': 'value' in errors}" v-on:focus="$delete(errors, 'value')" v-model="task.value">
                        <div class="invalid-feedback" v-if="'value' in errors">{{ errors['value'] }}</div>
                    </div>
                    <div class="form-group" v-if="task.type == 'http'">
                        <label class="form-label">Поиск контента <i class="ml-1 fal fa-question-circle" v-tooltip="{content: 'Отсутствие введенного значения в первых 10 килобайтах будет считаться ошибкой', placement: 'top'}"></i></label>
                        <input type="text" data-input="settings.keyword" class="form-control" v-bind:class="{ 'is-invalid': 'settings.keyword' in errors}" v-on:focus="$delete(errors, 'settings.keyword')" v-model="task.settings.keyword">
                        <div class="invalid-feedback" v-if="'settings.keyword' in errors">{{ errors['settings.keyword'] }}</div>
                    </div>
                    <div class="form-group" v-if="task.type == 'ping'">
                        <label class="form-label">Процент потерь <i class="ml-1 fal fa-question-circle" v-tooltip="{content: 'Процент потерь выше или равный введенному значению будет считаться ошибкой', placement: 'top'}"></i></label>
                        <input type="text" data-input="settings.loss" class="form-control" v-bind:class="{ 'is-invalid': 'settings.loss' in errors}" v-on:focus="$delete(errors, 'settings.loss')" v-model="task.settings.loss">
                        <div class="invalid-feedback" v-if="'settings.loss' in errors">{{ errors['settings.loss'] }}</div>
                    </div>
                    <button data-button="edit" class="hidden-md-down btn btn-success">Продолжить</button>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label class="form-label">Период проверки</label>
                        <select data-input="frequency" class="form-control select-minutes" v-bind:class="{ 'is-invalid': 'frequency' in errors}" v-on:focus="$delete(errors, 'frequency')" v-model="task.frequency">
                            <option value="1">1 минута</option>
                            <option value="3">3 минуты</option>
                            <option value="5">5 минут</option>
                            <option value="10">10 минут</option>
                            <option value="15">15 минут</option>
                            <option value="30">30 минут</option>
                            <option value="60">1 час</option>
                            <option value="180">3 часа</option>
                            <option value="360">6 часов</option>
                            <option value="720">12 часов</option>
                            <option value="1440">24 часа</option>
                        </select>
                        <div class="invalid-feedback" v-if="'frequency' in errors">{{ errors['frequency'] }}</div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Категория</label>
                        <select data-input="group" class="form-control select-group" v-bind:class="{ 'is-invalid': 'group_id' in errors}" v-on:focus="$delete(errors, 'group_id')" v-model="task.group_id">
                            <option value="null">Без категории</option>
                            <option v-for="group in groups" :key="group.id" v-bind:value="group.id">
                              {{ group.name }}
                            </option>
                        </select>
                        <div class="invalid-feedback" v-if="'group_id' in errors">{{ errors['group_id'] }}</div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Контакты</label>
                        <multiselect data-input="contacts" v-model="task.contacts" :custom-label="contactsName" trackBy="id" :close-on-select="false" open-direction="top" selectedLabel="" deselectLabel="" selectLabel="" placeholder="" :hideSelected="true" label="name" :multiple="true" :options="contacts"/>
                    </div>
                </div>
                <div class="col-12">
                    <button class="hidden-lg-up btn btn-success mt-3">Продолжить</button>
                </div>
              </div>
            </form>
          </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  
  export default {
    name: 'TasksEdit',
    props: ['task'],
    components: { Multiselect },
    data() {
      return {
        // Статус загрузки
        loading: true,
        // Контакты
        contacts: [
          {id: null, name: 'Выберите контакты для уведомления', $isDisabled: true},
        ],
        // Категории
        groups: [],
        // Ошибки
        errors: {}
      }
    },
    methods: {
      // Обновление списка контактов
      contactsListUpdate () 
      {
        // Индикатор загрузки
        this.loading = true;

        // Отправка запроса к API
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/contacts').then(response =>
        {
          var contacts = response.data.data.filter(function(data){
            return data.verify == 1
          })

          this.contacts.push(...contacts);
          this.loading = false;
        });
      },
      // Обновление списка категорий
      groupsListUpdate () 
      {
        // Индикатор загрузки
        this.loading = true;

        // Отправка запроса к API
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/groups/'+this.task.type).then(response =>
        {
          this.groups = response.data.data.map(function(data)
          {
            return {id: data.id, name: data.name};
          });
          this.loading = false;
        });
      },
      // Обновление данных задачи
      taskUpdate ()
      {
        // Подготовка данных
        var requestData = {
          'token':     localStorage.token, 
          'name':      this.task.name,
          'value':     this.task.value,
          'settings':  this.task.settings,
          'frequency': this.task.frequency,
          'group_id':  this.task.group_id == "null" ? null : this.task.group_id,
          'contacts':  this.task.contacts.map(element => element.id)
        };

        // Отправка запроса к API
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/tasks/'+this.task.id+'/edit', requestData).then(response => 
        {
          if(response.data.status == 'success')
            this.modalHide(true);
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      },
      // Улучшения вида контактов
      contactsName({id, name, value}) {
        if(value)
          return name+' - '+value;
        else
          return name;
      },
      // Показ модального окна
      modalShow() {
          this.$modal.show('TasksEdit');
      },
      // Скрытие модального окна
      modalHide(tasksReload = false) {
          this.$emit('close', tasksReload);
      }
    },
    // Подгрузка данных
    mounted () 
    {
      this.contactsListUpdate();
      this.groupsListUpdate();
      this.modalShow();

      // Добавление настроек задачи
      if(this.task.settings.length == 0)
      {
        if(this.task.type == 'http')
          this.task.settings = {'keyword': ''};

        if(this.task.type == 'ping')
          this.task.settings = {'loss': ''};
      }
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag:last-child {
    margin-bottom: 0;
  }
  .multiselect__tags {
    padding-bottom: 0.15rem !important;
  }
</style>